import {
  Box,
} from "@mui/material";
import GstReportsDetails from "./gstReportsDetails";


const GstReportsFullView = () => {
  return (
    <Box >
      <GstReportsDetails />
    </Box>
  );
};

export default GstReportsFullView;